var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.logs.length)?_c('b-table',{attrs:{"items":_vm.logs,"fields":_vm.tableColumns,"responsive":"","bordered":""}}):_c('b-alert',{staticClass:"p-1 mb-0",attrs:{"show":"","variant":"warning"}},[_vm._v(" Sin información ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }